// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"ba768c93","477":"ee2e24cf","564":"b716ce11","586":"cef3db6c","681":"b716ce11","717":"ee2e24cf","719":"93c16299"}[chunkId] + ".chunk.css";
};